import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';

const useTeamsSendTestMessage = () => {
    const userApi = useContainer(UserApi);

    const sendTestMessage = (): Promise<void> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.sendTeamsIntegrationTestMessage({
                onSuccess: () => resolve(),
                onError: error => reject(error),
            });

            exec();
        });
    };

    return { sendTestMessage };
};

export default useTeamsSendTestMessage;
